import React from "react";
import { joinNames } from "../helpers";
import style from "./style.module.scss";

export default function Label(
    props: React.LabelHTMLAttributes<HTMLLabelElement>
) {
    const { className, children, ...attr } = props;
    return (
        <label className={joinNames(className, style.label)} {...attr}>
            {children}
        </label>
    );
}
